import { render, staticRenderFns } from "./DefaultCalendar.vue?vue&type=template&id=2b2e590e&scoped=true&"
import script from "./DefaultCalendar.vue?vue&type=script&lang=ts&"
export * from "./DefaultCalendar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2e590e",
  null
  
)

export default component.exports